import * as React from "react";
import { merge } from "glamor";
import { themeOptions } from "styles/theme";

interface IProps {
    value: number;
    card: boolean;
    list: boolean;
}

const BulkDragBadge: React.FC<IProps> = (props) => {
    const { value } = props;

    const styles = React.useMemo(() => {
        return merge({
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            left: "-12px",
            top: "-8px",
            width: "44px",
            height: "34px",
            borderRadius: "20px",
            backgroundColor: themeOptions.palette.primary1Color,
            zIndex: 99,
            color: "white",
            fontSize: "1.48rem",
        });
    }, []);

    return <div {...styles}>{value}</div>;
};

export default BulkDragBadge;
